export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.21.0',
};
//# sourceMappingURL=buildEnv.js.map